import React from 'react';
import { componentService } from 'js/services/component.service';

export const PhoneVerification = React.lazy(() => import(/* webpackChunkName: "phone-verification" */ './PhoneVerification'));

componentService.registerPageComponents({ 'phone-verification': PhoneVerification });
